module.exports = __webpack_public_path__ + "static/media/pexels-kevin-menajang-982657.7ab1c1e0.jpg";